import { render } from "./UploadImagesManager.vue?vue&type=template&id=0b7ac3da&scoped=true&lang=pug"
import script from "./UploadImagesManager.vue?vue&type=script&lang=js"
export * from "./UploadImagesManager.vue?vue&type=script&lang=js"

import "./UploadImagesManager.vue?vue&type=style&index=0&id=0b7ac3da&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/quasar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7ac3da"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QTooltip,QBadge,QIcon,QBtn,QInnerLoading,QSpinner,QSpinnerDots});
